module.exports = __webpack_public_path__ + "static/img/__7444.55451b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__7444.jpg
// module id = iRFt
// module chunks = 0